export default __webpack_public_path__ + "static/media/uploader-oneTouchVerio-problem-2.e2e850f6.png";